import { Link } from 'react-router-dom';
import { shell } from '../../shell/shellClasses';
import type { FocusItem, FocusSeverity } from './types';

const severityStyle: Record<FocusSeverity, string> = {
  critical: 'border-[var(--shell-danger)]/40 bg-[var(--shell-danger)]/10 text-[var(--shell-danger)]',
  warning: 'border-[var(--shell-warning)]/40 bg-[var(--shell-warning)]/10 text-[var(--shell-warning)]',
  opportunity:
    'border-[var(--shell-success)]/40 bg-[var(--shell-success)]/10 text-[var(--shell-success)]',
};

export function FocusList({ items }: { items: FocusItem[] }) {
  if (items.length === 0) {
    return (
      <p className={`text-sm ${shell.muted}`}>Nothing needs your attention today.</p>
    );
  }

  return (
    <ul className="space-y-2" aria-label="Today's focus">
      {items.map((item) => (
        <li key={item.id}>
          <Link
            to={item.href}
            className={`flex min-h-[52px] flex-col gap-0.5 rounded-[var(--shell-radius-md)] px-3 py-2.5 transition-colors duration-[var(--shell-motion-fast)] hover:bg-[var(--shell-hover)] ${shell.focusRing} ${shell.surfaceElevated}`}
          >
            <div className="flex flex-wrap items-center gap-2">
              <span
                className={`rounded-[var(--shell-radius-sm)] border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${severityStyle[item.severity]}`}
              >
                {item.severity}
              </span>
              <span className="text-sm font-medium text-[var(--shell-fg)]">{item.title}</span>
            </div>
            <p className={`text-xs leading-relaxed ${shell.muted}`}>{item.evidence}</p>
          </Link>
        </li>
      ))}
    </ul>
  );
}
